module.exports = __webpack_public_path__ + "d50a3a522d5b1f3e5495c684404c7ea5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/menu-icons/clock.png
// module id = 2048
// module chunks = 1